(() => {
  const selector = '[data-sps-buy-now]';

  window.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const thumbnail = target && target.closest('.sps-quick-buy-modal .thumbnail-list__item .thumbnail');

    if (thumbnail) {
      const modal = thumbnail.closest('.sps-quick-buy-modal');
      const thumbnailItem = thumbnail.closest('.thumbnail-list__item');
      const mediaTarget = thumbnailItem && thumbnailItem.dataset.target;
      const mediaItems = modal ? Array.from(modal.querySelectorAll('.product__media-item')) : [];
      const mainSlide = mediaItems.find((item) => item.dataset.mediaId === mediaTarget);
      const gallery = mainSlide && mainSlide.closest('.product__media-list');

      if (!mainSlide || !gallery) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      modal.querySelectorAll('.thumbnail').forEach((item) => item.removeAttribute('aria-current'));
      thumbnail.setAttribute('aria-current', 'true');
      mediaItems.forEach((item) => item.classList.toggle('is-active', item === mainSlide));

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      gallery.scrollTo({ left: mainSlide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      return;
    }

    const button = target && target.closest(selector);
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const form = button.closest('form');
    const productSection = button.closest('section[id^="MainProduct-"]');
    const variantInput = form && form.querySelector('input[name="id"]');
    const quantityInput = productSection && productSection.querySelector('input[name="quantity"]');
    const variantId = variantInput && variantInput.value;
    const quantity = Math.max(1, Number.parseInt(quantityInput && quantityInput.value, 10) || 1);

    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    const root = window.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    const checkoutPermalink = `${normalizedRoot}cart/${encodeURIComponent(variantId)}:${quantity}`;

    window.location.assign(checkoutPermalink);
  }, true);
})();
